module.exports = __webpack_public_path__ + "static/media/logo.45194347.png";